<footer>
  <div
    fxLayout="column"
    fxLayout.gt-xs="row wrap"
    fxLayoutAlign="center center"
    fxLayoutAlign.gt-xs="space-between start"
    class="container"
  >
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      fxLayoutAlign.gt-xs="start start"
      class="footer-section"
    >
      <a
        [href]="'https://maps.google.com?daddr='
        + agencyService.agency.latitude + ','
        + agencyService.agency.longitude + '&amp;ll='"
        target="_blank"
        fxLayout="column"
        fxLayoutAlign="center"
        appGtagEvent
        eventCategory="contact"
        eventAction="click"
        eventLabel="maps_click"
        appFbqEvent="Lead"
        [customData]="{content_name: 'maps_click', content_category: 'click'}"
      >
        <img
          src="/assets/icons/logo_footer.svg"
          alt="logo footer"
          class="logo-footer"
          [routerLink]="basePath"
        >
      </a>
    </div>
    <div
      fxLayout="column"
      fxLayoutAlign="center start"
      class="footer-section"
    >
      <h4
        class="title"
      >
        {{ 'shared.footer.' + 'office' | translate }}
      </h4>
      <a
        [href]="'https://maps.google.com?daddr='
        + agencyService.agency.latitude + ','
        + agencyService.agency.longitude + '&amp;ll='"
        target="_blank"
        fxLayout="column"
        fxLayoutAlign="center"
        appGtagEvent
        eventCategory="contact"
        eventAction="click"
        eventLabel="maps_click"
        appFbqEvent="Lead"
        [customData]="{content_name: 'maps_click', content_category: 'click'}"
      >
        {{ agencyService.agency.address }}
      </a>
      <a
        [href]="'tel:' + agencyService.agency.phone"
        target="_blank"
        fxLayout="column"
        fxLayoutAlign="center"
        appGtagEvent
        eventCategory="contact"
        eventAction="click"
        eventLabel="phone_click"
        appFbqEvent="Lead"
        [customData]="{content_name: 'phone_click', content_category: 'click'}"
      >
        {{ agencyService.agency.phone | beautify }}
      </a>
      <a
        [href]="'mailto:' + agencyService.agency.email"
        target="_blank"
        fxLayout="column"
        fxLayoutAlign="center"
        appGtagEvent
        eventCategory="contact"
        eventAction="click"
        eventLabel="email_click"
        appFbqEvent="Lead"
        [customData]="{content_name: 'email_click', content_category: 'click'}"
      >
        {{ agencyService.agency.email }}
      </a>
      <h4
        class="title mt-10 rights"
      >
        {{ 'shared.footer.' + 'rights_reserved' | translate }} RomanescuPark ©2018
      </h4>
    </div>
    <div
      fxLayout="column"
      fxLayoutAlign="center start"
      class="footer-section"
    >
      <h4
        class="title"
      >
        Social Media:
      </h4>
      <app-social-icons-base [isTooltipBelow]="false"></app-social-icons-base>
    </div>
    <div
      fxLayout="column"
      fxLayoutAlign="center start"
      class="footer-section credits-wrapper"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="center center"
        fxLayoutAlign.gt-xs="start center"
        fxLayoutAlign.gt-sm="space-between center"
        class="credits-container"
      >
        <h4
          class="title credits"
        >
          {{ 'shared.footer.' + 'partner' | translate }}
        </h4>
        <a
          href="http://real-sol.ro/"
          rel="nofollow"
          target="_blank"
        >
          <img
            src="/assets/icons/partner.png"
            alt="real sol"
            class="partner-logo"
          >
        </a>
      </div>
      <a
        fxLayout="row"
        fxLayoutAlign="center center"
        fxLayoutAlign.gt-xs="start center"
        fxLayoutAlign.gt-sm="space-between center"
        href="https://vaunt.ro"
        rel="nofollow"
        target="_blank"
        class="credits-container mt-10"
      >
        <h4
          class="title credits"
        >
          Web solution by
          <br>
        </h4>
        <img
          src="/assets/icons/vaunt_logo.svg"
          alt="Vaunt"
          class="partner-logo2"
        >
      </a>
    </div>
  </div>

  <div
    fxLayout="row wrap"
    fxLayoutAlign="center center"
    fxGap="10px"
    class="container anpc"
  >
    <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="nofollow">
      <img
        src="/assets/images/anpc-sal.png"
        alt="Solutionarea Alternativa a Litigiilor"
      >
    </a>
    <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="nofollow">
      <img
        src="/assets/images/anpc-sol.png"
        alt="Solutionarea Online a Litigiilor"
      >
    </a>
  </div>
</footer>



// WEBPACK FOOTER //
// ./src/app/shared/components/footer/footer.component.html